import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import ErrorView from "~common/components/error-view"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import {PortalUser} from "~common/lib/models/portal-user"
import {APIError} from "~common/lib/types"
import SelectableTable from "~common/components/table/selectable-table"
import Require from "~common/components/require"
import UserEditView from "~users/components/user-edit-view"
import UserAdminQueryList from "~users/components/user-query-view"
import {Typography, Button} from '@mui/material'




const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  error?: APIError
  // ATTENTION: jdouglas This is a good technique for limiting possible values.  An Enum could also be used. Thu Dec 14 08:54:06 2017
  status: "loading" | "ready"
}

class UserAdmin extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {status: "loading"}
  }

 componentDidMount() {
    this.setState({status: "ready"})
  }

  render() {

    const {match} = this.props;
    const {classes, history}: {classes: ClassNameMap, history: any} = this.props
    var {error, status} = this.state
    var selectedUserID
    if(match && match.params && match.params.id) {
      selectedUserID = match.params.id
    }

   var errorView 
    if (error) {
      errorView = <ErrorView classes={{}} error={error} />
    }

    var view 
    if (status === "loading") {
      view = <LoadingView classes={{}} />
    } else if (selectedUserID) {
      view = <UserEditView userId={selectedUserID} match={match} history={history} classes={{}} />
    } else {
      view = <UserAdminQueryList></UserAdminQueryList> 
    }

    return (
      <AppView history={history} areaKey="user_admin">
        <Require classes={{}} requireOneOfFeatures={["User Admin"]}>
            {errorView}
            <Typography id="userAdminTitle" variant="h5" className={classes.heading}>
               User Administration
            </Typography>
            <div className={classes.container}>{view}
              {window.opener != null && status == "ready" && <div style={{textAlign:'right', paddingTop: 8}}>
                <Button color="inherit" variant="contained" onClick={()=>{window.close()}}>
                  Close
                </Button>
              </div>}
        </div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(UserAdmin)
